module.exports = __webpack_public_path__ + "img/amazon-logo.1f7ac30c.svg";